import { roles } from '@nxsys/store/constants';
import AssignmentListing from '../../../modules/asssignment/listing/';
import AssignmentDetail from '../../../modules/asssignment/detail';
import CreateAssignment from '../../../modules/asssignment/create';

export const assignmentsConfig = [
  {
    permittedRole: [roles.admin, roles.agency, roles.employee],
    path: '/assignments',
    element: <AssignmentListing />,
  },
  {
    permittedRole: [roles.admin, roles.agency, roles.employee],
    path: '/assignments/:assignmentId',
    element: <AssignmentDetail />,
  },
  {
    permittedRole: [roles.admin, roles.agency, roles.employee],
    path: '/assignments/create',
    element: <CreateAssignment />,
  },
];
